import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "../api/axios";

const Confirmation = () => {
  const location = useLocation();
  const uid = new URLSearchParams(location.search).get("uid");
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    let active = true;
    if (!uid) {
      setStatus("error");
      setMessage("Ο σύνδεσμος επιβεβαίωσης δεν είναι έγκυρος.");
      return () => {};
    }
    axios
      .get(`/confirmation/${encodeURIComponent(uid)}`)
      .then(() => active && setStatus("ready"))
      .catch((error) => {
        if (!active) return;
        setStatus("error");
        setMessage(
          error?.response?.data?.code === "token_expired"
            ? "Ο σύνδεσμος επιβεβαίωσης έχει λήξει."
            : "Ο σύνδεσμος επιβεβαίωσης δεν είναι έγκυρος ή έχει ήδη χρησιμοποιηθεί."
        );
      });
    return () => {
      active = false;
    };
  }, [uid]);

  const confirm = async () => {
    setStatus("confirming");
    try {
      await axios.post(`/confirmation/${encodeURIComponent(uid)}`);
      setStatus("confirmed");
    } catch (error) {
      setStatus("error");
      setMessage(
        error?.response?.data?.code === "token_expired"
          ? "Ο σύνδεσμος επιβεβαίωσης έχει λήξει."
          : "Η επιβεβαίωση δεν ολοκληρώθηκε. Ζητήστε νέο email επιβεβαίωσης."
      );
    }
  };

  return (
    <section className="container">
      {status === "loading" && <p>Έλεγχος συνδέσμου…</p>}
      {status === "ready" && (
        <>
          <h1>Επιβεβαίωση email</h1>
          <p>Πατήστε το κουμπί για να ολοκληρώσετε την επιβεβαίωση.</p>
          <button className="submit" type="button" onClick={confirm}>
            Επιβεβαίωση email
          </button>
        </>
      )}
      {status === "confirming" && <p>Ολοκλήρωση επιβεβαίωσης…</p>}
      {status === "confirmed" && (
        <>
          <h1>Επιβεβαιώθηκε το email σας</h1>
          <Link to="/login">Σύνδεση</Link>
        </>
      )}
      {status === "error" && <p className="errmsg">{message}</p>}
    </section>
  );
};

export default Confirmation;
